import { format } from 'd3-format';

export const round = (number, precision) => {
  const shift = (num, prec, reverseShift) => {
    let acc = prec;
    if (reverseShift) {
      acc = -prec;
    }
    const numArray = (`${num}`).split('e');
    return+(`${numArray[0]}e${numArray[1] ? (+numArray[1] + acc) : acc}`);
  };
  return shift(Math.round(shift(number, precision, false)), precision, true);
};

export const customFormat2 = format(',.2f');
export const customFormat0 = format(',.0f');
